<template>
<div class='grid-wrap'>
  <dx-data-grid ref='refCompanyGrid'
    :data-source='dataSource'
    :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
    :hover-state-enabled = "true" :allowColumnResizing = 'true'
    column-resizing-mode = 'widget' :allow-column-reordering = "true"
    :height="gridHeight" :row-alternation-enabled="true"
    keyExpr="seqId" :focusedRowEnabled="true"
    @toolbarPreparing="onToolbarPreparing"
    @rowDblClick="onRowDblClick"
  >
    <DxSearchPanel
      :visible="true"
      placeholder="검색..."
    />
    <DxFilterRow
      :visible="false"
      apply-filter="auto"
    />
    <DxColumnFixing :enabled="true"/>
    <DxColumn
      :allowEditing="false"
      :visible="true"
      caption="고객사명"
      data-field="고객사명"
      :min-width="140"
      :fixed="true"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="포지션제목"
      data-field="포지션제목"
      :min-width="300"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="채용진행"
      data-field="채용진행단계"
      :min-width="120"
      alignment="center"
      sortOrder="asc"
      >
        <DxLookup
          :data-source="processingLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="채용직급"
      data-field="채용직급"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="요구경력"
      data-field="경력"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="요구학력"
      data-field="학력"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="studyLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="선호성별"
      data-field="선호성별"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="manWoomanLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="선호연령"
      data-field="선호연령"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="연봉수준(만)"
      data-field="연봉수준"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="false"
      :visible="true"
      caption="컨설턴트"
      data-field="컨설턴트"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="employeeInfo"
          display-expr="성명"
          value-expr="사번"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="모집분야"
      data-field="모집분야"
      :min-width="100"
      alignment="center"
      >
        <DxLookup
          :data-source="categoryLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>

      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="코웍여부"
      data-field="코웍여부"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="coworkLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="코웍수수료"
      data-field="코웍수수료"
      format="#,##0.0%"
      dataType="number"
      :min-width="90"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="홈페이지게제"
      data-field="홈페이지게제"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="homePageLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>

      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="근무예정지"
      data-field="근무예정지"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="기숙조건"
      data-field="기숙조건"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="liveLookup"
          display-expr="코드명"
          value-expr="코드명"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="기타처우"
      data-field="기타처우"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="수수료율"
      data-field="수수료율"
      format="#,##0.0%"
      dataType="number"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="false"
      :visible="isExporing"
      caption="고객사코드"
      data-field="고객사코드"
      :min-width="80"
      alignment="center"
      edit-cell-template="companyGridTemplate"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="작성자"
      data-field="createdId"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="employeeInfo"
          display-expr="성명"
          value-expr="사번"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="등록일"
      data-field="createdTime"
      alignment="center"
      format="yyyy-MM-dd"
      dataType="date"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="수정자"
      data-field="updatedId"
      alignment="center"
      :min-width="100"
      >
        <DxLookup
          :data-source="employeeInfo"
          display-expr="성명"
          value-expr="사번"
        />
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="수정일"
      data-field="updatedTime"
      alignment="center"
      format="yyyy-MM-dd"
      dataType="date"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="사용유무"
      data-field="사용유무"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="삭제유무"
      data-field="삭제유무"
      :min-width="100"
      >
      </DxColumn>

      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="포지션정보(사내)"
      data-field="포지션정보"
      :min-width="100"
      edit-cell-template="htmlEditor"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="isExporing"
      caption="채용정보(사외)"
      data-field="채용정보"
      :min-width="100"
      edit-cell-template="htmlEditor"
      >
      </DxColumn>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="standard" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="single"/>
    <dx-paging :enabled="false"/>
    <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
    <dx-sorting mode="multiple"/>
  </dx-data-grid>
</div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup
} from 'devextreme-vue/data-grid'

export default {
  name: 'customerSummartComponent',
  data: function () {
    return {
      dataSource: null,
      isExporing: false,
      gridHeight: null,
      openLookup: ConstDef.YN_LOOKUP,
      infoLookup: this.$store.getters.getBaseDataByType(ConstDef.유치경로),
      contractLookup: this.$store.getters.getBaseDataByType(ConstDef.계약단계),
      companyTypeLookup: this.$store.getters.getBaseDataByType(ConstDef.회사규모),
      employeeInfo: this.$store.getters.getEmployee,
      processingLookup: this.$store.getters.getBaseDataByType(ConstDef.채용단계),
      categoryLookup: this.$store.getters.getBaseDataByType(ConstDef.모집분야),
      coworkLookup: ConstDef.코웍단독,
      homePageLookup: ConstDef.게재비게재,
      studyLookup: ConstDef.요구학력,
      manWoomanLookup: ConstDef.남녀,
      ageLookup: ConstDef.연령대,
      liveLookup: this.$store.getters.getBaseDataByType(ConstDef.주거조건)
    }
  },
  components: {
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.refreshDataSource()
  },
  mounted () {
    this.gridHeight = (screen.height - 320) / 3
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onRowDblClick (e) {
      this.$router.push(`/main/positionSearch?seqId=${e.data.seqId}`)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b><span style="color:black;font-size:1.2rem;">&#10016;</span> 포지션 정보</b></div>`
          }
        }
      )
    },
    refreshDataSource () {
      this.$_sp.runFindProc('spFindAllpositionLimit', { limit: 10 })
        .then(data => {
          this.dataSource = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
